<template>
  <div class="flex w-full items-center justify-between">
    <div class="flex items-center space-x-3">
      <img
        class="rounded-full"
        :src="staticUrls.countryFlagUrl(country.code)"
        :width="flagSize"
        :height="flagSize"
        :alt="country.name"
      />
      <h3
        class="text-text-neutral-primary font-medium"
        :class="showCity ? 'text-sm' : 'text-base'"
      >
        <span v-if="showCity">{{ city.name }}, </span>
        <span
          :class="showCity ? 'text-text-neutral-quaternary font-normal' : ''"
          >{{ country.name }}</span
        >
      </h3>
    </div>
    <button
      v-if="!isSingleOffer"
      type="button"
      class="flex items-center space-x-0.5"
      @click="emit('onShowAllOffers', country.code)"
    >
      <span class="text-text-positive-primary text-sm font-medium">
        {{ $t('general.all') }}
      </span>
      <ChevronIcon class="text-text-positive-primary h-4 w-4" />
    </button>
  </div>
</template>

<script setup lang="ts">
  import type { hotOffersTypes } from '@/entities/hot-offers';

  import { staticUrls } from '@/shared/config';

  import ChevronIcon from '@/assets/images/chevron-arrow-16x16.svg?component';

  const emit = defineEmits<{
    onShowAllOffers: [countryCode: string];
  }>();

  withDefaults(
    defineProps<{
      country: hotOffersTypes.MappedCountry;
      city?: hotOffersTypes.MappedCity;
      showCity?: boolean;
      isSingleOffer?: boolean;
      flagSize?: number;
    }>(),
    {
      showCity: false,
      isSingleOffer: false,
      flagSize: 28,
    },
  );
</script>
